import * as React from "react";

import { AppProvider } from "../AppProvider";

import { Styletron } from "./Styletron";

function Main(props) {
  // eslint-disable-next-line react/prop-types
  const { theme, app, children } = props;
  return (
    <Styletron theme={theme}>
      <AppProvider value={app || AppProvider.defaultValue}>{children}</AppProvider>
    </Styletron>
  );
}

export { Main };
